// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable @typescript-eslint/no-unused-vars */
// "use client";
// import {
//   useFetchPickListShipment,
//   usePickRequestInboundAWBMutation,
// } from "../../../apis/pickupApis";
// import { IconBox, IconCheckupList, IconVolume } from "@tabler/icons-react";
// import ListView from "../../../components/common/ListView";
// import TextareaField from "../../../components/common/TextareaField";
// import { useEffect, useState } from "react";
// import ToggleButtonCustom from "./ToggleButtonCustom";
// import toast from "react-hot-toast";

// const InfoRow = ({
//   label,
//   value,
//   className,
// }: {
//   label: string;
//   value: React.ReactNode;
//   className?: string;
// }) => (
//   <div
//     className={`flex justify-between items-center py-1.5 border-b border-slate-100 last:border-0 w-full gap-4 text-xs sm:text-sm ${className}`}
//   >
//     <span className="capitalize text-slate-500 font-medium">{label}</span>
//     <span className="text-[#1E293B] font-semibold text-right break-all">
//       {typeof value === "string" ? value || "—" : value}
//     </span>
//   </div>
// );

// type Props = {
//   pickup: any;
//   selectedRows: string[];
//   setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
//   missingToggle: boolean;
//   setMissingToggle: React.Dispatch<React.SetStateAction<boolean>>;
//   damageToggle: boolean;
//   setDamageToggle: React.Dispatch<React.SetStateAction<boolean>>;
//   missingMessage: string;
//   setMissingMessage: React.Dispatch<React.SetStateAction<string>>;
//   damageMessage: string;
//   setDamageMessage: React.Dispatch<React.SetStateAction<string>>;
//   setAwbNumbersProp?: (awbs: string[]) => void;
//   type?: string;
// };

// type PickupRequest = {
//   awb: string;
//   status: string;
//   [key: string]: any;
// };

// const SectionHeader = ({
//   icon: Icon,
//   title,
//   className = "border-b border-[#FBD037]/30 pb-2 mb-3",
// }: {
//   icon: any;
//   title: string;
//   className?: string;
// }) => (
//   <div className={`flex items-center gap-2 ${className}`}>
//     <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
//       <Icon size={16} className="text-[#212121]" stroke={1.5} />
//     </div>
//     <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
//       {title}
//     </p>
//   </div>
// );

// const RiwVerificationModal = ({
//   pickup,
//   selectedRows,
//   setSelectedRows,
//   missingToggle,
//   setMissingToggle,
//   damageToggle,
//   setDamageToggle,
//   missingMessage,
//   setMissingMessage,
//   damageMessage,
//   setDamageMessage,
//   type,
// }: Props) => {
//   const [awbText, setAwbText] = useState("");
//   const [awbNumbers, setAwbNumbers] = useState<string[]>([]);
//   const [verifiedShipment, setVerifiedShipment] = useState<any>();
//   const [verifiedShipments, setVerifiedShipments] = useState<any[]>([]);
//   const [error, setError] = useState({
//     error: false,
//     message: "",
//   });

//   console.log(pickup, "pickup");

//   const handleAwbPaste = (value: string) => {
//     setAwbText(value);

//     const pastedAwbs = value
//       .split(/[\s,]+/)
//       .map((a) => a.trim())
//       .filter(Boolean);

//     const shipments = pickup?.shipments ?? [];
//     const matchedIds = shipments
//       .filter((s: any) => pastedAwbs.includes(s.awbNumber))
//       .map((s: any) => s.id);

//     setSelectedRows(matchedIds);
//     setAwbNumbers(pastedAwbs); // keep for API call
//   };
//   const playBeep = (text?: string, type: "normal" | "error" = "normal") => {
//     const Ctx =
//       (window as any).AudioContext || (window as any).webkitAudioContext;

//     // 🔹 Speak if text is provided
//     if (text) {
//       const utterance = new SpeechSynthesisUtterance(text);
//       utterance.lang = "en-US";
//       utterance.rate = 0.7; // slower
//       utterance.pitch = 1.2; // more feminine
//       utterance.volume = 1;

//       const voices = speechSynthesis.getVoices();
//       const femaleVoice =
//         voices.find((v) => /female/i.test(v.name)) ||
//         voices.find((v) => v.name.includes("Google US English")) ||
//         voices[0];

//       if (femaleVoice) utterance.voice = femaleVoice;

//       speechSynthesis.speak(utterance);
//     }

//     // 🔹 Only play beep if error type
//     if (type !== "error" || !Ctx) return;

//     const context = new Ctx();
//     const oscillator = context.createOscillator();
//     const gainNode = context.createGain();

//     oscillator.connect(gainNode);
//     gainNode.connect(context.destination);

//     // 🔹 Distinct alarm-like sound
//     oscillator.type = "square";
//     oscillator.frequency.value = 880;
//     gainNode.gain.setValueAtTime(0.5, context.currentTime);

//     oscillator.start(context.currentTime);
//     oscillator.stop(context.currentTime + 0.5);
//   };

//   const { data: pickupData, refetch: pickupRefetch } = useFetchPickListShipment(
//     1,
//     10,
//     "",
//     pickup.pickupId,
//   );

//   useEffect(() => {
//     pickupRefetch();
//   }, []);

//   const { mutate: generatePickupRequestAWBInbound } =
//     usePickRequestInboundAWBMutation();
//   const shipments = pickupData?.shipments ?? [];

//   const allSelected =
//     selectedRows.length > 0 && selectedRows.length === shipments.length;

//   const handleSelectAll = () => {
//     const shipments = pickupData?.shipments ?? [];
//     if (allSelected) {
//       setSelectedRows([]);
//     } else {
//       setSelectedRows(shipments.map((shipment: any) => shipment.id));
//     }
//   };

//   const handleRowSelect = (awb: string) => {
//     setSelectedRows((prev) =>
//       prev.includes(awb) ? prev.filter((id) => id !== awb) : [...prev, awb],
//     );
//   };

//   const handleCreateAWBInbound = (awb: any) => {
//     const onSuccess = (data: any) => {
//       setVerifiedShipment(data);
//       pickupRefetch();
//       setAwbText("");
//       playBeep(data?.verifyShipments?.[0]?.city, "normal");
//       setSelectedRows([...selectedRows, data?.verifyShipments?.[0]?.id]);
//       setVerifiedShipments([...verifiedShipments, data?.verifyShipments?.[0]]);
//       setError({ error: false, message: "" });
//     };

//     const onError = (error: any) => {
//       console.error("❌ AWB inbound error:", error);
//       toast.error(`${error}`);
//       setAwbText("");
//       setVerifiedShipments([]);
//       setError({ error: true, message: error });
//       playBeep(error, "error");
//     };

//     generatePickupRequestAWBInbound(
//       { pickupId: pickup?.id, awbNumbers: [awb] },
//       { onSuccess, onError },
//     );
//   };

//   return (
//     <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3 shadow-sm hover:shadow-md">
//       <div className="flex justify-between items-center gap-4 border-b border-[#FBD037]/30 pb-2 mb-3">
//         <SectionHeader className="" icon={IconBox} title="Inbound" />
//         <div
//           className={`${
//             error?.error
//               ? "bg-[red]/10 border border-[red]/30 text-[red]"
//               : "bg-[#20BF55]/10 border border-[#20BF55]/30 text-[#166534]"
//           } px-4 py-1 rounded-lg w-full`}
//         >
//           <div className="flex justify-between items-center">
//             <div className="flex items-center gap-1">
//               <h2 className="text-lg font-bold">
//                 {verifiedShipment?.verifyShipments?.[0]?.city || "NA"}{" "}
//               </h2>
//               {/* <p className="text-xs opacity-80">
//                ( {verifiedShipment?.verifyShipments?.[0]?.awbNumber || "NA"} )
//               </p> */}
//             </div>
//             <IconVolume size={20} />
//           </div>
//         </div>
//       </div>
//       <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
//       <div className="space-y-4">
//         <div className="grid grid-cols-1 gap-4">
//           <div className="bg-[#FCFDF8] border border-[#D2D2D2] rounded-2xl p-4">
//             <textarea
//               rows={4}
//               className="w-full resize-none outline-none bg-transparent text-sm text-[#212121]/70"
//               placeholder="Paste AWB numbers here (each AWB must be space or list separated)"
//               value={awbText}
//               onChange={(e) => {
//                 setAwbText(e.target.value);
//                 handleCreateAWBInbound(e.target.value);
//               }}
//             />
//           </div>
//         </div>
//         <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3 shadow-sm hover:shadow-md">
//           <div className="flex justify-between items-center gap-4 border-b border-[#FBD037]/30 pb-2 mb-3">
//             <SectionHeader
//               className=""
//               icon={IconCheckupList}
//               title="RIW Verification"
//             />
//             <div className="flex items-center gap-6 border-t border-slate-100">
//               <div className="flex items-center gap-2 text-sm font-medium">
//                 <span>Missing</span>
//                 <ToggleButtonCustom
//                   checked={missingToggle}
//                   onChange={setMissingToggle}
//                 />
//               </div>
//               <div className="flex items-center gap-2 text-sm font-medium">
//                 <span>Damage</span>
//                 <ToggleButtonCustom
//                   checked={damageToggle}
//                   onChange={setDamageToggle}
//                 />
//               </div>
//             </div>
//           </div>
//   <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
//           <div className="grid grid-cols-1 gap-6">
//             <div className="space-y-2">
//               <h3 className="text-sm font-semibold text-slate-700">
//                 Pending Verification
//               </h3>
//               <ListView<PickupRequest>
//                 mailDivClassName="w-full p-0 border rounded-2xl max-h-[300px] overflow-x-hidden overflow-y-auto"
//                 mainDivClassName="bg-[#FCFDF8]"
//                 trClassName="hover:bg-[#FBD037]/20 group text-xs"
//                 tdClassName="p-2"
//                 data={
//                   pickupData?.shipments?.filter(
//                     (shipment: any) =>
//                       !selectedRows?.includes(shipment?.id) &&
//                       shipment?.status !== "RECEIVE_IN_WAREHOUSE",
//                   ) ?? []
//                 }
//                 onRowClick={(client) => console.log("Clicked:", client)}
//                 columns={[
//                   {
//                     label: (
//                       <label className="relative flex items-center cursor-pointer select-none">
//                         <input
//                           type="checkbox"
//                           checked={allSelected}
//                           onChange={handleSelectAll}
//                           className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                         />
//                         <span className="absolute left-[4px] top-[1px] text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 pointer-events-none">
//                           ✓
//                         </span>
//                         <span className="ml-2 font-semibold">
//                           AWB / Routing
//                         </span>
//                       </label>
//                     ),
//                     render: (c) => {
//                       const isChecked = selectedRows.includes(c.id);
//                       return (
//                         <div className="flex flex-col gap-1 py-1.5 text-left">
//                           <div className="flex items-center gap-2">
//                             <label className="relative flex items-center cursor-pointer">
//                               <input
//                                 type="checkbox"
//                                 checked={isChecked}
//                                 onChange={() => handleRowSelect(c.id)}
//                                 className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                               />
//                               <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                                 ✓
//                               </span>
//                             </label>
//                             <span className="font-mono font-bold text-slate-800 tracking-wider text-xs">
//                               {c.awbNumber}
//                             </span>
//                           </div>
//                           <span className="text-[10px] text-slate-500 font-medium pl-6 leading-tight whitespace-normal max-w-[200px]">
//                             {c.senderCity || "—"} ➔ {c.receiverCity || "—"}
//                             {c.receiverCountry ? `, ${c.receiverCountry}` : ""}
//                           </span>
//                         </div>
//                       );
//                     },
//                   },
//                   {
//                     label: "Status",
//                     render: (c) => {
//                       const getStatusClasses = (status: string) => {
//                         switch (status) {
//                           case "Out for delivery":
//                           case "Dispatch":
//                             return "bg-[#EBF7CE] text-[#212121] border border-[#C6E59D]";
//                           case "Delivered":
//                             return "bg-[#EEEEEE] text-[#212121] border border-[#CFCFCF]";
//                           case "Undelivered":
//                             return "bg-[#F7E9CE] text-[#212121] border border-[#E6C98A]";
//                           default:
//                             return "bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121]";
//                         }
//                       };
//                       return (
//                         <div className="flex justify-center items-center py-1.5">
//                           <span
//                             className={`rounded-full px-2.5 py-0.5 text-[10px] font-medium text-center whitespace-nowrap ${getStatusClasses(
//                               c.status,
//                             )}`}
//                           >
//                             {c.status === "PICKUP_COLLECTED"
//                               ? "COLLECTED"
//                               : c.status}
//                           </span>
//                         </div>
//                       );
//                     },
//                   },
//                 ]}
//               />
//             </div>
//             <div className="space-y-2">
//               <h3 className="text-sm font-semibold text-slate-700">
//                 Verified Shipments
//               </h3>
//               <ListView
//                 mailDivClassName="w-full p-0 border rounded-2xl max-h-[300px] overflow-x-hidden overflow-y-auto"
//                 mainDivClassName="bg-[#FCFDF8]"
//                 trClassName="hover:bg-[#FBD037]/20 group text-xs"
//                 tdClassName="p-2"
//                 data={
//                   pickupData?.shipments?.filter((shipment: any) =>
//                     selectedRows?.includes(shipment?.id),
//                   )
//                     ? pickupData?.shipments?.filter((shipment: any) =>
//                         selectedRows?.includes(shipment?.id),
//                       )
//                     : verifiedShipments?.length > 0
//                       ? verifiedShipments
//                       : []
//                 }
//                 onRowClick={(client) => console.log("Clicked:", client)}
//                 columns={[
//                   {
//                     label: "AWB / Routing",
//                     render: (c: any) => (
//                       <div className="flex flex-col gap-1 py-1.5 text-left">
//                         <div className="flex items-center gap-2">
//                           <div className="bg-green-500 w-4 h-4 rounded-full flex justify-center items-center text-white text-[10px] shrink-0 font-bold shadow-sm">
//                             ✓
//                           </div>
//                           <span className="font-mono font-bold text-slate-800 tracking-wider text-xs">
//                             {c.awbNumber}
//                           </span>
//                         </div>
//                         <span className="text-[10px] text-slate-500 font-medium pl-6 leading-tight whitespace-normal max-w-[200px]">
//                           {c.senderCity || "—"} ➔ {c.receiverCity || "—"}
//                           {c.receiverCountry ? `, ${c.receiverCountry}` : ""}
//                         </span>
//                       </div>
//                     ),
//                   },
//                   {
//                     label: "Status",
//                     render: (c: any) => {
//                       const getStatusClasses = (status: string) => {
//                         switch (status) {
//                           case "Received":
//                             return "bg-[#20BF55]/20 text-[#212121] border border-[#20BF55]";
//                           case "Damaged":
//                             return "bg-[#212121]/20 text-[#212121] border border-[#212121]";
//                           case "Missing":
//                             return "bg-[#FF4848]/20 text-[#212121] border border-[#FF4848]";
//                           default:
//                             return "bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121]";
//                         }
//                       };
//                       return (
//                         <div className="flex justify-center items-center py-1.5">
//                           <span
//                             className={`rounded-full px-2.5 py-0.5 text-[10px] font-medium text-center whitespace-nowrap ${getStatusClasses(
//                               c.status,
//                             )}`}
//                           >
//                             {c.status === "PICKUP_COLLECTED"
//                               ? "COLLECTED"
//                               : c.status}
//                           </span>
//                         </div>
//                       );
//                     },
//                   },
//                 ]}
//               />
//             </div>
//           </div>
//         {(missingToggle || damageToggle) && (
//           <div className="grid grid-cols-1 gap-4">
//             {missingToggle && (
//               <TextareaField
//                 rows={3}
//                 label={"Enter Message For Missing"}
//                 placeholder={"Explain Missing shipment"}
//                 name={"missingMessage"}
//                 value={missingMessage}
//                 onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
//                   setMissingMessage(e.target.value)
//                 }
//               />
//             )}
//             {damageToggle && (
//               <TextareaField
//                 rows={3}
//                 label={"Enter Message for Damage"}
//                 placeholder={"Explain Damage shipment"}
//                 name={"damageMessage"}
//                 value={damageMessage}
//                 onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
//                   setDamageMessage(e.target.value)
//                 }
//               />
//             )}
//           </div>
//         )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RiwVerificationModal;

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";
import {
  useFetchPickListShipment,
  usePickRequestInboundAWBMutation,
} from "../../../apis/pickupApis";
import {
  IconBox,
  IconCheckupList,
  IconRosetteDiscountCheck,
  IconVolume,
} from "@tabler/icons-react";
import ListView from "../../../components/common/ListView";
import TextareaField from "../../../components/common/TextareaField";
import { useEffect, useState } from "react";
import ToggleButtonCustom from "./ToggleButtonCustom";
import toast from "react-hot-toast";

const InfoRow = ({
  label,
  value,
  className,
}: {
  label: string;
  value: React.ReactNode;
  className?: string;
}) => (
  <div
    className={`flex justify-between items-center py-1.5 border-b border-slate-100 last:border-0 w-full gap-4 text-xs sm:text-sm ${className}`}
  >
    <span className="capitalize text-slate-500 font-medium">{label}</span>
    <span className="text-[#1E293B] font-semibold text-right break-all">
      {typeof value === "string" ? value || "—" : value}
    </span>
  </div>
);

type Props = {
  pickup: any;
  selectedRows: string[];
  setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
  missingToggle: boolean;
  setMissingToggle: React.Dispatch<React.SetStateAction<boolean>>;
  damageToggle: boolean;
  setDamageToggle: React.Dispatch<React.SetStateAction<boolean>>;
  missingMessage: string;
  setMissingMessage: React.Dispatch<React.SetStateAction<string>>;
  damageMessage: string;
  setDamageMessage: React.Dispatch<React.SetStateAction<string>>;
  setAwbNumbersProp?: (awbs: string[]) => void;
  type?: string;
};

type PickupRequest = {
  awb: string;
  status: string;
  id: string;
  senderCity?: string;
  receiverCity?: string;
  receiverCountry?: string;
  [key: string]: any;
};

const SectionHeader = ({
  icon: Icon,
  title,
  className = "border-b border-[#FBD037]/30 pb-2 mb-3",
}: {
  icon: any;
  title: string;
  className?: string;
}) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const RiwVerificationModal = ({
  pickup,
  selectedRows,
  setSelectedRows,
  missingToggle,
  setMissingToggle,
  damageToggle,
  setDamageToggle,
  missingMessage,
  setMissingMessage,
  damageMessage,
  setDamageMessage,
  type,
}: Props) => {
  const [awbText, setAwbText] = useState("");
  const [awbNumbers, setAwbNumbers] = useState<string[]>([]);
  const [verifiedShipment, setVerifiedShipment] = useState<any>();
  const [verifiedShipments, setVerifiedShipments] = useState<any[]>([]);
  const [error, setError] = useState({
    error: false,
    message: "",
  });

  const { data: pickupData, refetch: pickupRefetch } = useFetchPickListShipment(
    1,
    10,
    "",
    pickup.pickupId,
  );

  useEffect(() => {
    pickupRefetch();
  }, []);

  const { mutate: generatePickupRequestAWBInbound } =
    usePickRequestInboundAWBMutation();
  const shipments = pickupData?.shipments ?? [];

  const allSelected =
    selectedRows.length > 0 && selectedRows.length === shipments.length;

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(shipments.map((shipment: any) => shipment.id));
    }
  };

  const handleRowSelect = (id: string) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((row) => row !== id) : [...prev, id],
    );
  };

  // Original paste handler (calls API with the whole text, same as before)
  const handleCreateAWBInbound = (awb: any) => {
    const onSuccess = (data: any) => {
      setVerifiedShipment(data);
      pickupRefetch();
      setAwbText("");
      playBeep(data?.verifyShipments?.[0]?.city, "normal");
      setSelectedRows([...selectedRows, data?.verifyShipments?.[0]?.id]);
      setVerifiedShipments([...verifiedShipments, data?.verifyShipments?.[0]]);
      setError({ error: false, message: "" });
    };

    const onError = (error: any) => {
      console.error("❌ AWB inbound error:", error);
      toast.error(`${error}`);
      setAwbText("");
      setVerifiedShipments([]);
      setError({ error: true, message: error });
      playBeep(error, "error");
    };

    generatePickupRequestAWBInbound(
      { pickupId: pickup?.id, awbNumbers: [awb] },
      { onSuccess, onError },
    );
  };

  const handleAwbPaste = (value: string) => {
    setAwbText(value);
    // The original code passed the whole value to the API; we keep that exact behavior
    // but we also select matching rows.
    const pastedAwbs = value
      .split(/[\s,]+/)
      .map((a) => a.trim())
      .filter(Boolean);

    const matchedIds = shipments
      .filter((s: any) => pastedAwbs.includes(s.awbNumber))
      .map((s: any) => s.id);

    setSelectedRows(matchedIds);
    setAwbNumbers(pastedAwbs);

    // If there is exactly one AWB, call the API as before
    if (pastedAwbs.length === 1) {
      handleCreateAWBInbound(pastedAwbs[0]);
    } else if (pastedAwbs.length > 1) {
      // Original only called for first? We'll call for each to be safe.
      pastedAwbs.forEach((awb) => handleCreateAWBInbound(awb));
    }
  };

  // playBeep kept as is
  const playBeep = (text?: string, type: "normal" | "error" = "normal") => {
    const Ctx =
      (window as any).AudioContext || (window as any).webkitAudioContext;
    if (text) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = "en-US";
      utterance.rate = 0.7;
      utterance.pitch = 1.2;
      utterance.volume = 1;
      const voices = speechSynthesis.getVoices();
      const femaleVoice =
        voices.find((v) => /female/i.test(v.name)) ||
        voices.find((v) => v.name.includes("Google US English")) ||
        voices[0];
      if (femaleVoice) utterance.voice = femaleVoice;
      speechSynthesis.speak(utterance);
    }
    if (type !== "error" || !Ctx) return;
    const context = new Ctx();
    const oscillator = context.createOscillator();
    const gainNode = context.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(context.destination);
    oscillator.type = "square";
    oscillator.frequency.value = 880;
    gainNode.gain.setValueAtTime(0.5, context.currentTime);
    oscillator.start(context.currentTime);
    oscillator.stop(context.currentTime + 0.5);
  };

  const getStatusClasses = (status: string) => {
    switch (status) {
      case "Out for delivery":
      case "Dispatch":
        return "bg-[#EBF7CE] text-[#212121] border border-[#C6E59D]";
      case "Delivered":
        return "bg-[#EEEEEE] text-[#212121] border border-[#CFCFCF]";
      case "Undelivered":
        return "bg-[#F7E9CE] text-[#212121] border border-[#E6C98A]";
      default:
        return "bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121]";
    }
  };

  const formatStatus = (status: string) => {
    if (!status) return "—";
    return status
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3 shadow-sm hover:shadow-md">
      <div className="flex justify-between items-center gap-4 border-b border-[#FBD037]/30 pb-2 mb-3">
        <SectionHeader className="" icon={IconBox} title="Inbound" />
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        <div
          className={`${
            error?.error
              ? "bg-[red]/10 border border-[red]/30 text-[red]"
              : "bg-[#20BF55]/10 border border-[#20BF55]/30 text-[#166534]"
          } px-4 py-1 rounded-lg w-full`}
        >
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-1">
              <h2 className="text-lg font-bold">
                {verifiedShipment?.verifyShipments?.[0]?.city || "NA"}
              </h2>
            </div>
            <IconVolume size={20} />
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {/* Paste area – unchanged */}
        <div className="bg-[#FCFDF8] border border-[#D2D2D2] rounded-2xl p-4">
          <textarea
            rows={4}
            className="w-full resize-none outline-none bg-transparent text-sm text-[#212121]/70"
            placeholder="Scan first pallet , box or bag then scan AWB"
            value={awbText}
            onChange={(e) => handleAwbPaste(e.target.value)}
          />
        </div>

        {/* RIW Verification – now with ONE table */}
        <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3 shadow-sm hover:shadow-md">
          <div className="flex justify-between items-center gap-4 border-b border-[#FBD037]/30 pb-2 mb-3">
            <SectionHeader
              className=""
              icon={IconCheckupList}
              title="RIW Verification"
            />
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 text-sm font-medium">
                <span>Missing</span>
                <ToggleButtonCustom
                  checked={missingToggle}
                  onChange={setMissingToggle}
                />
              </div>
              <div className="flex items-center gap-2 text-sm font-medium">
                <span>Damage</span>
                <ToggleButtonCustom
                  checked={damageToggle}
                  onChange={setDamageToggle}
                />
              </div>
            </div>
          </div>

          {/* Single List – shows all shipments */}
          <div className="space-y-2">
            <ListView<PickupRequest>
              mailDivClassName="w-full p-0 border rounded-2xl max-h-[300px] overflow-x-hidden overflow-y-auto"
              mainDivClassName="bg-[#FCFDF8]"
              trClassName="hover:bg-[#FBD037]/20 group text-xs"
              tdClassName="p-2"
              data={shipments}
              columns={[
                {
                  label: (
                    <label className="relative flex items-center cursor-pointer select-none">
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={handleSelectAll}
                        className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                      />
                      <span className="absolute left-[4px] top-[1px] text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 pointer-events-none">
                        ✓
                      </span>
                      <span className="ml-2 font-semibold">AWB</span>
                    </label>
                  ),
                  render: (c) => {
                    const isChecked = selectedRows.includes(c.id);
                    return (
                      <div className="flex flex-col gap-1 py-1.5 text-left">
                        <div className="flex items-center gap-2">
                          {isChecked ? (
                            <IconRosetteDiscountCheck color="green" size={18} />
                          ) : (
                            <label className="relative flex items-center cursor-pointer">
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={() => handleRowSelect(c.id)}
                                className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                              />
                              <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                                ✓
                              </span>
                            </label>
                          )}
                          <span className="font-mono font-bold text-slate-800 tracking-wider text-xs">
                            {c.awbNumber}
                          </span>
                        </div>
                      </div>
                    );
                  },
                },
                {
                  label: "Status",
                  render: (c) => (
                    <div className="flex justify-center items-center py-1.5">
                      <span
                        className={`rounded-full px-2.5 py-0.5 text-[10px] font-medium text-center whitespace-nowrap ${getStatusClasses(
                          c.status,
                        )}`}
                      >
                        {c.status === "PICKUP_COLLECTED"
                          ? "COLLECTED"
                          : formatStatus(c.status)}
                      </span>
                    </div>
                  ),
                },
              ]}
            />
          </div>

          {/* Missing / Damage textareas – unchanged */}
          {(missingToggle || damageToggle) && (
            <div className="grid grid-cols-1 gap-4 pt-2 border-t border-slate-200">
              {missingToggle && (
                <TextareaField
                  rows={3}
                  label="Message for Missing"
                  placeholder="Explain Missing shipment"
                  name="missingMessage"
                  value={missingMessage}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                    setMissingMessage(e.target.value)
                  }
                />
              )}
              {damageToggle && (
                <TextareaField
                  rows={3}
                  label="Message for Damage"
                  placeholder="Explain Damage shipment"
                  name="damageMessage"
                  value={damageMessage}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                    setDamageMessage(e.target.value)
                  }
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RiwVerificationModal;
